import React, { useState, useEffect } from "react";
import NavBar from "./NavBar";
export const PageLayout = (props) => {
  const [getfontSize, setFontSize] = useState("Normal");
  useEffect(() => {
    const saved = localStorage.getItem("GET_FONT_SIZE");
    if (saved) {
      setFontSize(JSON.parse(saved));
    } else {
      setFontSize("Normal");
    }
  }, []);
  return (
    <>
      <NavBar />

      <div id="app" style={{ height: "100vh" }}>
        <div className={getfontSize}>
          <main> {props.children}</main>
        </div>
      </div>
    </>
  );
};
